<template>
    <div class="container fondo">
        <img src="../assets/bg/pre6.jpg" alt="" class="bg">
        <img src="../assets/bg/pre6-celular.jpg" alt="" class="bgcel">
        <div class="contbut">
            
        </div>
    </div>  
    <div class="container contpre">
        <div class="col-lg-7 divpre6">
            <Control 
                p="¿Por qué deberías reutilizar el agua de la lavadora?"
                estilo="pregunta6"
                link="p7"
                r1="Para ahorrar agua."
                r2="Para hacerla sentir importante."
                r3="Para lavar el agua que ya se ensució"
                real = "a"
            
            />
        </div>
    </div>
    
</template>

<script>
import Control from "@/components/Control";
import Fondos from '@/components/Fondos.vue'
export default {
    components:{
        Control,
        Fondos
    }
}
</script>


